// extracted by mini-css-extract-plugin
module.exports = {"taskDetails":"TaskDetails_taskDetails__2Wu4Y","attachments":"TaskDetails_attachments__3zyJf"};